import IconFilters from '@assets/icons/filters.svg?react';
import {
 Box,
 IconButton,
 ListItemText,
 Menu,
 MenuItem,
 useTheme,
} from '@mui/material';
import {
 GRID_DEFAULT_LOCALE_TEXT as defaultTranslation,
 GridFilterOperator,
} from '@mui/x-data-grid-premium';
import { MouseEvent, useState } from 'react';
import { useFormContext } from 'react-hook-form';

import { FormValues, StructureType } from '../../../types/types';
import { GRID_DEFAULT_LOCALE_TEXT } from '../XTable/translation';

const translation = GRID_DEFAULT_LOCALE_TEXT || defaultTranslation;

const OperatorMenu = ({
 operators,
 filter,
 columnExists,
 value,
 structure,
}: {
 readonly operators: GridFilterOperator[];
 filter: string;
 columnExists: boolean;
 value: FormValues;
 structure: StructureType;
}) => {
 //  console.log(filter, operators, value);
 const th = useTheme();
 const { setValue, trigger } = useFormContext();
 const [menuState, setMenuState] = useState<{
  id: string;
  anchorEl: HTMLElement | null;
 } | null>({ id: '-1', anchorEl: null });

 // Handle menu open
 const handleMenuOpen = (id: string, event: MouseEvent<HTMLElement>): void => {
  setMenuState({ id, anchorEl: event.currentTarget });
 };

 // Handle menu close
 const handleMenuClose = (): void => {
  setMenuState(null);
 };
 const handleOperatorChange = (item: GridFilterOperator) => {
  setValue(`operators[${filter}]`, item.value);
  setMenuState(null);
 };

 // probably will need to rewrite prepareFilters to handle this
 //  const getOperators = (type: string) => {
 //   const currentType = structure.Type;

 //   switch (currentType) {
 //    case 'datetime':
 //     return getGridDateOperators(true).filter((o) =>
 //      ['onOrBefore', 'onOrAfter', 'between'].includes(o.value),
 //     );
 //    case 'int32':
 //    case 'int16':
 //    case 'double':
 //    case 'decimal':
 //     return getGridNumericOperators().filter((o) =>
 //      ['=', '!=', '<=', '>='].includes(o.value),
 //     );
 //    default:
 //     return operators;
 //   }
 //  };
 const newOperators = operators;

 return (
  <>
   <IconButton
    disabled={!columnExists}
    //    aria-label={`${trans} menu`}
    color="primary"
    sx={{
     width: 24,
     height: 24,
     display: 'flex',
     alignItems: 'center',
     justifyContent: 'center',
     padding: '4px',
    }}
    onClick={(event) => handleMenuOpen(filter, event)}
   >
    <Box
     sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      '& path': {
       stroke: value ? th.palette.kemek.blue : th.palette.kemek.lightestGray,
      },
     }}
    >
     <IconFilters style={{ width: '20px', height: '18px' }} />
    </Box>
   </IconButton>
   <Menu
    MenuListProps={{ disablePadding: true }}
    anchorEl={menuState?.id === filter ? menuState?.anchorEl : null}
    open={menuState?.id === filter && Boolean(menuState?.anchorEl)}
    onClose={handleMenuClose}
    // MenuListProps={{
    //  'aria-labelledby': 'basic-button',
    // }}
   >
    {newOperators.map((item) => (
     <MenuItem
      key={`menu_${filter}_${item.value}`}
      selected={value.toString() === item.value}
      onClick={() => handleOperatorChange(item)}
     >
      <ListItemText>
       {translation.headerFilterOperator[
        item.value as keyof typeof translation.headerFilterOperator
       ] || item.value}
      </ListItemText>
     </MenuItem>
    ))}
    <MenuItem
     key={`menu_${filter}_empty`}
     onClick={() => {
      setValue(`operators[${filter}]`, '');
      trigger(`operators[${filter}]`);
      if (structure?.Type === 'datetime') {
       setValue(filter, '');
       setValue(`dateRanges[${filter}].from`, '');
       setValue(`dateRanges[${filter}].to`, '');
       setValue(`dateRanges[${filter}].year`, '');
       setValue(`dateRanges[${filter}].month`, '');
       setValue(`dateRanges[${filter}].week`, '');
       setValue(`dateRanges[${filter}].period`, '');
       trigger(`dateRanges[${filter}].period`);
      } else {
       setValue(filter, '');
       trigger(filter);
      }
      setMenuState(null);
     }}
    >
     <ListItemText sx={{ color: th.palette.kemek.red }}>Išvalyti</ListItemText>
    </MenuItem>
   </Menu>
  </>
 );
};

export default OperatorMenu;
